import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import { Auth } from '../core/constants/auth';
import { Routes } from '../core/constants';
import AdminRouter from '../pages/Admin';
import McpAuthorizePage from '../pages/McpAuthorize';
import AuthorizedRouter from './Authorized';

function Main() {
  const init = localStorage.getItem(Auth.ACCESS_TOKEN_KEY);

  const location = useLocation();
  const redirectPath = location.pathname + location.search;

  if (location.pathname !== '/login') {
    localStorage.setItem('redirectPath', redirectPath);
  }

  if (!init) {
    return <AuthorizedRouter/>;
  }

  return (
    <Switch>
      <Route path={Routes.mcpAuthorize} component={McpAuthorizePage} exact />
      <Route component={AdminRouter} />
    </Switch>
  );
}

const AppRouter = () => (
  <Router>
    <Route path='/' component={Main} />
  </Router>
);

export default AppRouter;
